import * as React from 'react';
import { IgcSliderLabelComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * Allows formatting the values of the slider as string values.
 * The text content of the slider labels is used for thumb and tick labels.
 * @class
 */
export const IgrSliderLabel = /* @__PURE__ */ createComponent({
  tagName: 'igc-slider-label',
  displayName: 'IgrSliderLabel',
  elementClass: Component,
  react: React,
});

export type IgrSliderLabel = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrSliderLabelModule = Component;
